import { render } from "./SidebarFooter.vue?vue&type=template&id=529e6416&scoped=true"
import script from "./SidebarFooter.vue?vue&type=script&lang=js"
export * from "./SidebarFooter.vue?vue&type=script&lang=js"

import "./SidebarFooter.vue?vue&type=style&index=0&id=529e6416&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529e6416"]])

export default __exports__